import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { embeddedMedia, validateProfileText } from 'app/validators/profileText'
import styles from './styles'

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
}

const defaultFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
]

const textFormats = defaultFormats.filter(
  format => !['image', 'link'].includes(format),
)
const textModules = {
  ...defaultModules,
  toolbar: defaultModules.toolbar.filter(group => !group.includes('link')),
}

class RichTextEditor extends Component {
  static propTypes = {
    className: PropTypes.string,
    textOnly: PropTypes.bool,
    maxLength: PropTypes.number,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
  }
  static defaultProps = {
    style: {},
    textOnly: false,
    size: 'small',
  }

  state = { validationMessage: null }

  preventMediaTransfer = event => {
    if (!this.props.textOnly) return
    const transfer = event.clipboardData || event.dataTransfer
    if (!transfer) return
    if (
      transfer.files?.length ||
      Array.from(transfer.items || []).some(item => item.kind === 'file') ||
      embeddedMedia(transfer.getData?.('text/html')) ||
      embeddedMedia(transfer.getData?.('text/plain'))
    ) {
      event.preventDefault()
      event.stopPropagation()
      this.setState({
        validationMessage:
          'Solo se permite texto con formato básico, sin imágenes ni contenido incrustado.',
      })
    }
  }

  handleChange = (value, delta, source, editor) => {
    if (this.restoring) return
    const { textOnly, maxLength, onChange } = this.props
    const validationMessage = validateProfileText(value, maxLength, textOnly)
    if (validationMessage) {
      const quill = this.editor && this.editor.getEditor()
      const accepted =
        this.props.value !== undefined
          ? this.props.value
          : this.lastAcceptedValue || this.props.defaultValue || ''
      // Quill edits before notifying us. Restore the complete prior document
      // through its API so its internal value and the form cannot diverge.
      // Initial normalization can add paragraph markup before our child ref
      // exists. Keep the original form value and let the user shorten it.
      if (quill) {
        this.restoring = true
        try {
          quill.setContents(quill.clipboard.convert(accepted), 'api')
        } finally {
          this.restoring = false
        }
      }
      this.setState({ validationMessage })
      return
    }
    this.lastAcceptedValue = value
    if (this.state.validationMessage) this.setState({ validationMessage: null })
    if (onChange) onChange(value, delta, source, editor)
  }

  UNSAFE_componentWillMount() {
    if (typeof window !== 'undefined') {
      this.ReactQuill = require('react-quill')

      this.forceUpdate()
    }
  }

  getPlainText = () => {
    if (this.editor && typeof this.editor.getEditor === 'function') {
      return this.editor.getEditor().getText()
    }

    return ''
  }

  render() {
    const { ReactQuill } = this
    const { className, size, textOnly, maxLength, ...rest } = this.props
    if (!ReactQuill) {
      return <textarea {...rest} maxLength={maxLength} />
    }
    return (
      <div
        className={className}
        onPasteCapture={this.preventMediaTransfer}
        onDropCapture={this.preventMediaTransfer}
      >
        <ReactQuill
          ref={r => {
            this.editor = r
          }}
          className={size}
          {...rest}
          modules={textOnly ? textModules : rest.modules || defaultModules}
          formats={textOnly ? textFormats : rest.formats || defaultFormats}
          onChange={this.handleChange}
        />
        {this.state.validationMessage && (
          <p role="alert">{this.state.validationMessage}</p>
        )}
        <style jsx global>
          {styles}
        </style>
      </div>
    )
  }
}

export default RichTextEditor
